import styled from 'styled-components'
import { Button as UIKitButton } from '@swapxco/uikit'
import { getNeomorphismBoxShadowValue } from 'theme'

export const Button = styled(UIKitButton)`
  box-shadow: ${({ theme, variant }) => getNeomorphismBoxShadowValue(theme.colors.background, 3)};
  padding: 20px 16px;
  border-radius: 50px;
`